import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { GaIcon } from '~icon';
import { TransitionItem } from '~helpers';
import alertPropTypes from '../../prop-types/alertPropTypes';
import Container from './Container';
import CloseButton from './CloseButton';
import MessageContainer from './MessageContainer';

var DefaultAlert = function DefaultAlert(_ref) {
  var alertType = _ref.alertType,
      close = _ref.close,
      children = _ref.children,
      inProp = _ref.inProp,
      props = _objectWithoutPropertiesLoose(_ref, ["alertType", "close", "children", "inProp"]);

  return /*#__PURE__*/React.createElement(TransitionItem, Object.assign({
    inProp: inProp,
    appear: true,
    transitionType: "fadeInFadeOut"
  }, props), /*#__PURE__*/React.createElement(Container, {
    alertType: alertType,
    role: "alert"
  }, !!close && /*#__PURE__*/React.createElement(CloseButton, {
    alertType: alertType,
    onClick: close
  }, /*#__PURE__*/React.createElement(GaIcon, {
    icon: "x",
    size: 16,
    color: "currentColor"
  })), /*#__PURE__*/React.createElement(MessageContainer, null, children)));
};

DefaultAlert.defaultProps = {
  alertType: 'info',
  close: null,
  inProp: false
};
export default DefaultAlert;